/* eslint-disable no-restricted-globals */
/* eslint-env worker */

self.onmessage = function FileProcessorWorkerMessage(event) {
  const { type, data, id } = event.data

  try {
    switch (type) {
      case 'PROCESS_FILES':
        processFiles(data.files, id)
        break
      default:
        self.postMessage({
          type: 'ERROR',
          id,
          error: `Unknown message type: ${type}`,
        })
    }
  } catch (error) {
    self.postMessage({
      type: 'ERROR',
      id,
      error: error.message,
    })
  }
}

function processFiles(files, requestId) {
  const processedFiles = []
  let completedCount = 0

  files.forEach((file, index) => {
    try {
      const url = URL.createObjectURL(file)
      
      const processedFile = {
        id: `${Date.now()}-${file.name}-${index}`,
        type: file.type.startsWith('image/') ? 'image' : 'video',
        source: 'upload',
        file,
        preview: url,
        url,
        size: file.size,
        name: file.name,
        lastModified: file.lastModified,
      }

      processedFiles.push(processedFile)
      completedCount += 1

      self.postMessage({
        type: 'PROGRESS',
        id: requestId,
        progress: {
          completed: completedCount,
          total: files.length,
          percentage: Math.round((completedCount / files.length) * 100),
        },
        file: processedFile,
      })
    } catch (error) {
      self.postMessage({
        type: 'FILE_ERROR',
        id: requestId,
        error: `Error processing file ${file.name}: ${error.message}`,
        fileName: file.name,
      })
    }
  })

  self.postMessage({
    type: 'COMPLETE',
    id: requestId,
    files: processedFiles,
  })
}
